import ApplicationOperationForm from "@/components/field/operations/ApplicationOperationForm";
import PlantingOperationForm from "@/components/field/operations/PlantingOperationForm";
import HarvestOperationForm from "@/components/field/operations/HarvestOperationForm";
import IrrigationOperationForm from "@/components/field/operations/IrrigationOperationForm";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tab, Tabs } from "@heroui/react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { Key } from "@react-types/shared";
import { useTranslation } from "react-i18next";
import useFieldDashboard from "@/lib/fieldDashboard/useFieldDashboard";
import useFeatureFlag from "@/lib/featureFlags/useFeatureFlags";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/operations/add",
)({
    validateSearch: (search: Record<string, unknown>): { type?: string } => ({
        type:
            typeof search.type === "string" &&
                ["planting", "application", "irrigation", "harvest"].includes(
                    search.type,
                )
                ? search.type
                : undefined,
    }),
    component: RouteComponent,
});

function RouteComponent() {
    const { fieldId, fieldQuery } = useFieldDashboard() ?? {};
    const { irrigationEnabled } = useFeatureFlag();
    const { type: typeFromSearch } = Route.useSearch();
    const fieldIsIrrigated = useMemo(() => {
        if (!fieldQuery?.data) return false;
        return fieldQuery.data.irrigation_systems.length > 0;
    }, [fieldQuery?.data]);


    const [type, setType] = useState<Key>(typeFromSearch ?? "application");
    const { t } = useTranslation("operations");
    return (
        <div className="p-2 flex flex-col gap-2">
            <div className="flex flex-row items-center justify-between mb-2">
                <Button
                    size="sm"
                    as={Link}
                    to="/dashboard/fields/$fieldId/operations"
                    params={
                        {
                            fieldId,
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        } as any
                    }
                >
                    <FontAwesomeIcon icon={faChevronLeft} /> {t("backToOperations")}
                </Button>
            </div>
            <Tabs fullWidth selectedKey={type} onSelectionChange={setType} color="primary" variant="underlined">
                <Tab title="Planting" key="planting">
                    <PlantingOperationForm />
                </Tab>
                <Tab title="Application" key="application">
                    <ApplicationOperationForm />
                </Tab>
                {irrigationEnabled && fieldIsIrrigated && (
                    <Tab title="Irrigation" key="irrigation">
                        <IrrigationOperationForm />
                    </Tab>
                )}
                <Tab title="Harvest" key="harvest">
                    <HarvestOperationForm />
                </Tab>
            </Tabs>
        </div>
    );
}
